<div class="workSpace">
    <!--Encabezado de la página-->
  <div class="w3-container w3-contenedor-template w3-light-grey" style="height: 7vh;">
    <!--Titulo de la página-->
    <div class="w3-quarter padreizquierda">
      <div class="w3-row hijoizquierda">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"><b>{{ 'menu.'+dataService.moduleSelect | translate }}</b></span>
        <span class="w3-text-deep-orange"> &bull; </span>
        <span class="w3-margin-left-filter w3-text-orange w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }}</span>
      </div>
    </div>
    <div class="w3-rest">
      @if (filtroNorm) {
        <div class="w3-twothird">
          <!--Filtros de años-->
          <div class="w3-half w3-margin-left-filter">
            <div class="w3-third hijoizquierda">
              <button class="w3-button w3-right" [mat-menu-trigger-for]="menuAniosP2">
                {{'filtros.anio' | translate}}
                <mat-icon class="iconoMen">keyboard_arrow_down</mat-icon>
              </button>
              <mat-menu class="w3-medium" #menuAniosP2="matMenu" xPosition="before">
                @for (an of aniosDisponibles; track $index) {
                  <button mat-menu-item (click)="anioChange(an); $event.stopPropagation();">
                    <div class="w3-quarter" style="padding-top: 3px;">
                      <input type="checkbox" style="cursor: pointer; "
                        [checked]="an.check">
                    </div>
                    <div class="w3-rest" style="padding-left: 10px;">{{an.name}}</div>
                  </button>
                }              
              </mat-menu>
            </div>
            <div class="w3-rest hijoizquierda">
              <div class="w3-row padreizquierda containerChips" id="contenedor_btnanios">
                <div class="w3-row hijoizquierda chips">
                  @for (anios of aniosDisponibles; track $index) {
                    <div class="filtroMesAnioSeleccionado" [ngClass]="anios.check?
                    'w3-round-btn-large w3-gris-btn w3-show w3-left w3-center w3-elemento-menu' : 'w3-hide'">
                      <span class="contenidoChips">{{anios.name}}</span>
                    </div>
                  }              
                </div>
              </div>
            </div>
          </div>
          <!--Filtros de meses-->
          <div class="w3-rest w3-margin-left-filter ">
            <div class="w3-third  hijoizquierda">
              <button class="w3-button w3-right" [mat-menu-trigger-for]="menumeses">
                {{'filtros.mes' | translate}}
                <mat-icon class="iconoMen">keyboard_arrow_down</mat-icon>
              </button>
              <mat-menu class="w3-medium" #menumeses="matMenu">
                @for (mes of mesesDisponibles; track $index) {
                  <button mat-menu-item (click)="$event.stopPropagation(); mesChange(mes);">
                    <div class="w3-quarter" style="padding-top: 3px;">
                      <input type="checkbox" style="cursor: pointer; "
                        [checked]="mes.check">
                    </div>
                    <div class="w3-rest" style="padding-left: 10px;">{{mes.name}}</div>
                  </button>
                }            
              </mat-menu>
            </div>
            <div class="w3-rest hijoizquierda">
              <div class="w3-row padreizquierda containerChips" id="contenedor_btnanios">
                <div class="w3-row hijoizquierda chips">
                  @for (mesfil of mesesDisponibles; track $index) {
                    <div class="filtroMesAnioSeleccionado" [ngClass]="mesfil.check?
                    'w3-round-btn-large w3-gris-btn w3-show w3-left w3-center w3-elemento-menu' : 'w3-hide'">
                      <span class="contenidoChips">{{mesfil.name}}</span>
                    </div>
                  }              
                </div>
              </div>
            </div>
          </div>
        </div>
      }    
      @if (!filtroNorm) {
        <div class="w3-twothird">
          <div class="w3-quarter_e hijoizquierda">
            <button class="w3-button w3-right" [mat-menu-trigger-for]="menuPeriodos">
              {{'filtros.per'|translate}}
              <mat-icon class="iconoMen">keyboard_arrow_down</mat-icon>
            </button>
            <mat-menu #menuPeriodos="matMenu" xPosition="before">
              @for (an of aniosDisponibles; track $index) {
                <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="childMenu">
                  <span>{{an.name}}</span>
                </button>
                <mat-menu #childMenu="matMenu" [overlapTrigger]="false">
                  @for (child of DatosAnios.mesesDisponibles; track $index) {
                    @if (an.name === child.year) {
                      <button mat-menu-item (click)="$event.stopPropagation(); seleccionarmes(child)">
                        <div class="w3-quarter">
                          <input style="cursor: pointer; margin-top: 5px;"
                                (change)="seleccionarmes(child)"
                                [checked]="child.check" type="checkbox"
                                (click)="$event.stopPropagation();">
                        </div>
                        <div class="w3-rest">
                          <span style="margin-left: 15px; ">{{child.name}}</span> 
                        </div>           
                      </button>
                    }
                  }                
                </mat-menu>
              }
            </mat-menu>
          </div>
          <div class="w3-rest hijoizquierda">
            <div class="w3-noventa2" id="Cchip">
              <div class="w3-row padreizquierda containerChips" id="contenedor_btnanios">
                <div class="w3-row hijoizquierda chips ">
                  @for (mesfil of DatosAnios.mesesDisponibles; track $index) {
                    <div class="filtroMesAnioSeleccionado" (click)="seleccionarmes(mesfil)" [ngClass]="mesfil.check?
                    'w3-round-btn-large w3-gris-btn w3-show w3-left w3-center w3-elemento-menu w3-button' : 'w3-hide'">
                      <div style="padding: 0 0 3px 5px; float: left;">{{mesfil.name}}-{{anioEsc(mesfil.year)}} </div>
                      <div style="padding: 4px 0 0 0; float: left;"><mat-icon [ngStyle]="{'color':'gray'}" class="w3-tiny">close</mat-icon></div>
                    </div>
                  }                
                </div>
              </div>
            </div>
            @if (aniosSelec()) {
              <div class="w3-rest">
                <mat-icon [ngStyle]="{'color':'gray'}" class="iconoClos w3-button" [matMenuTriggerFor]="menuanios2">more_horiz</mat-icon>
              </div> 
              <mat-menu #menuanios2="matMenu" xPosition="before">
                <div class="w3-row hijoizquierda chips ">
                  @for (mesfil of DatosAnios.mesesDisponibles; track $index) {
                    <div class="filtroMesAnioSeleccionado" (click)="seleccionarmes(mesfil)" [ngClass]="mesfil.check?
                    'w3-round-btn-large w3-gris-btn w3-show w3-left w3-center w3-elemento-menu w3-button' : 'w3-hide'">
                      <div style="padding: 0 0 3px 5px; float: left;">{{mesfil.name}}-{{anioEsc(mesfil.year)}} </div>
                      <div style="padding: 4px 0 0 0; float: left;"><mat-icon [ngStyle]="{'color':'gray'}" class="w3-tiny">close</mat-icon></div>
                    </div>
                  }                
                </div>
              </mat-menu>
            }          
          </div>
        </div>
      }
      
      <!--Cambio de tipo de Filtro-->
      <div class="w3-quarter_e w3-margin-left-filter" >
        <div class="hijoizquierda " style="margin-left: 1vh; padding-top: 0;">
          <button mat-menu-item (click)="$event.stopPropagation(); cambioFiltro();">
            <div class="w3-quarter " >
              <input style="cursor: pointer; margin-top: 5px;" 
                [checked]="!filtroNorm" type="checkbox"
                >
            </div>
            <div class="w3-rest " style="padding-top: 5px; padding-left: 5px;">
              {{'filtros.filtrado'|translate}}
            </div>
          </button>        
        </div>
      </div>
      <!--Borrar filtros-->
      <div class="w3-rest padreizquierda w3-right">
        <div class="w3-row hijoizquierda">
          <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="quitar_filtros()" style="transform: scale(0.9);" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
              <img src="./../../../../assets/img/eraser.png">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="workSpaceTab">
    <div class="w3-row" style="height: 42vh;" id="Zona1">
      <!--Encabezado del primer cuadrante-->
      <div class="w3-row w3-write w3-header-cuadrante" style="height: 6vh;">
        <!--Titulo de la primer gráfica-->
        <div class="w3-twothird hijoIzquierdaTitle w3-titulo-contenidomenu">
          <div class="hijoizquierdaTitle">
            @if (gtablaP) {
              <span class="w3-margin-left-contenido">{{TituloGrafPrinc | capitalize:'first'}} {{milTab1}}</span>
            }@else {
              <span class="w3-margin-left-contenido">{{TituloGrafPrinc | capitalize:'first'}}</span>
            }
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{subTituloGrafPrinc}}</span>
          </div>
        </div>
        <!--Menu Gráfica principal-->
        <div class="w3-rest w3-right-align_rest">
          <div class="w3-right hijoderechaTitle">
            @if(showLabels && tipoSelec !== tipoGraf.STACKED) {
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="changeLabel = !changeLabel"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
            }
            @if (!gtablaP) {
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" fontSet="material-icons-outlined" [ngStyle]="{'color':'gray'}" 
                (click)="showLabels = !showLabels" matTooltip="{{'graf.activar' | translate}}">
                {{ !showLabels ? 'label' : 'label_off' }}
              </mat-icon>
            }        
            <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" (click)="ampliar()" onclick="document.getElementById('graficasModal').style.display='block'">zoom_out_map</mat-icon>
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuP2">more_vert</mat-icon>
          </div>
          <mat-menu #menuP2="matMenu" xPosition="before">
            <!-- <button mat-menu-item>
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">search</mat-icon>
              <span>Buscar</span>
            </button> -->
            <button mat-menu-item [matMenuTriggerFor]="GraficasP2">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
              {{'menu.graficas'|translate}}
            </button>
            <div mat-menu-item [matMenuTriggerFor]="menuP.perspectivas" #trigger="matMenuTrigger">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">account_tree</mat-icon>
              {{'menu.Perspectivas'|translate}}
            </div>
            @if (gtablaP) {
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="moneda">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">paid</mat-icon>
                @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.milesUsd' | translate}}</span>}
                @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.milesMxn' | translate}}</span>}
                @if(smMoneda === 'Gs'){<span>{{ 'menu.milesGs' | translate}}</span>}
              </button>
            }        
            <mat-divider></mat-divider>
            @if (gtablaP) {
              <button mat-menu-item (click)="export_csv(1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            }@else {
              <button mat-menu-item (click)="export_img(1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            }        
          </mat-menu>

          <mat-menu #moneda="matMenu">
            <button mat-menu-item (click)="CambMon('Mil',1)">
              <span>{{'menu.miles'|translate}}</span>
            </button>
            <button mat-menu-item (click)="CambMon('Pesos',1)">
              @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.usd' | translate}}</span>}
              @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.mxn' | translate}}</span>}
              @if(smMoneda === 'Gs'){<span>{{ 'menu.gs' | translate}}</span>}
            </button>
          </mat-menu>

          <mat-menu #GraficasP2="matMenu">
            <button (click)="stackTabla(false,tipoGraf.STACKED)" mat-menu-item>Barras</button>
            <button (click)="stackTabla(false,tipoGraf.LINE)" mat-menu-item>Lineal</button>
            <button (click)="stackTabla(false,tipoGraf.AREA)" mat-menu-item>Área</button>
            <button (click)="stackTabla(true,'')" mat-menu-item>Tabla</button>
          </mat-menu>
          <app-menu-perspectivas #menuP 
            [tipo]="submenus" 
            [tablero]="'concentracion'"
            (eventClick)="filterChange($event);">
          </app-menu-perspectivas>
        </div>
      </div>
      <!--Gráfica principal -->
      <div class="w3-row grafInfo">
        <div class=" w3-row grafTabla">
          @if (gtablaP) {
            <div class="w3-encabezado-table" style="width: 97vw;">
              <div class="w3-table-all w3-scroll">
                <table class="w3-table">
                  <thead>
                    <tr class="w3-table-titleLow w3-center">
                      <th class="stikyColum">{{'filtros.periodo' | translate}}</th>
                      <th class="stikyColum w3-border-right-balance"></th>
                      @for(ele of Titulos; track $index){
                        <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{ele}}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (element of dataSource2; track element) {
                      <tr  class="w3-table-trtd borderInf">
                        @for (inf of displayedColumns2; track inf; let i = $index) {
                          <td class="borderAllLow marginsH alinLeft" style="width: 10%;">
                            @switch (i) {
                              @case (0) {
                                <span style="font-weight: bold;">{{ element.name }}</span>
                              }
                              @case (1) {
                                <span style="font-weight: bold;">
                                  {{ element.servicios }} <br />
                                  {{ element.servicios1 }}
                                </span>
                              }
                              @default {
                                {{smMoneda}} {{ formatearnormal(element[inf], miles1) }} <br />
                                {{ formatearnormal2(element[inf + '1']) }}
                              }
                            }
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }@else {
            <app-graficador
              [etiquetas]="showLabels"
              [data]="stack"
              [labels]="etiquetas"
              [type]="tipoSelec"
              [axisX]="xAxisLabel"
              [axisY]="yAxisLabel"
              [zona]="1"
              [colors]="colorScheme"
              [formatEtiquetas]="true"
              [changeLabel]="changeLabel"
              [legend]="{enabled: true, position: 'right'}"
              [animations]="true"
              [speedAnimations]="500"
            ></app-graficador>
          }  
        </div>      
        @if (!gtablaP) {
          <div class=" w3-rest info-icon">
            <mat-icon (click)="popChange()" onclick="document.getElementById('graficasModal').style.display='block'">info</mat-icon>
          </div>
        }
      </div>
    </div>
    <!--Zona secundaria de la pagina-->
    <div class="w3-row">
      <div class="w3-row w3-light-grey" style="height: 2vh;"></div>
      <div class="w3-row">
        <!--Zona 2-->
        <div class="w3-twothird" id="Zona2" style="width: 64% !important;">
          <!--Encabezado de zona 2-->
          <div class="w3-row" style="height: 6vh;">
            <!--Titulo de la zona 2-->
            <div class="w3-twothird hijoIzquierdaTitle w3-titulo-contenidomenu">
              <div class="hijoizquierdaTitle">
                @if (gtablas) {
                  <span class="w3-margin-left-contenido">{{TituloGrafSec | capitalize:'first'}} {{milTab2}}</span>
                }@else {
                  <span class="w3-margin-left-contenido">{{TituloGrafSec | capitalize:'first'}}</span>
                }
                <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
                <span class=" w3-margin-left-filter w3-subtitulo">{{subTituloGrafSec}}</span>
              </div>
            </div>
            <!--Menú de la zona 2-->
            <div class="w3-rest w3-right">
              <div class="w3-right hijoderechaTitle">
                @if (!gtablas) {
                  <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" fontSet="material-icons-outlined" [ngStyle]="{'color':'gray'}" 
                    (click)="showLabels2 = !showLabels2" matTooltip="{{'graf.activar' | translate}}">
                    {{ !showLabels2 ? 'label' : 'label_off' }}
                  </mat-icon>
                }  
                <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" (click)="ampliarG2()" onclick="document.getElementById('graficasModal').style.display='block'">zoom_out_map</mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuG2p2">more_vert</mat-icon>
              </div>
              <mat-menu #menuG2p2="matMenu" xPosition="before">
                <button mat-menu-item [matMenuTriggerFor]="graficasZon2" mat-menu-item>
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'menu.graficas'|translate}}</span>
                </button>
                <div mat-menu-item [matMenuTriggerFor]="menu2.perspectivas">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">account_tree</mat-icon>{{'menu.Perspectivas'|translate}}
                </div>
                @if (gtablas) {
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="moneda2">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">paid</mat-icon>
                    @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.milesUsd' | translate}}</span>}
                    @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.milesMxn' | translate}}</span>}
                    @if(smMoneda === 'Gs'){<span>{{ 'menu.milesGs' | translate}}</span>}
                  </button>
                }            
                <mat-divider></mat-divider>
                @if (gtablas) {
                  <button mat-menu-item (click)="export_csv(2)">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                }@else {
                  <button mat-menu-item (click)="export_img(2)">
                    <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                } 
              </mat-menu>
              <mat-menu #moneda2="matMenu">
                <button mat-menu-item (click)="CambMon('Mil',2)">
                  <span>{{'menu.miles'|translate}}</span>
                </button>
                <button mat-menu-item (click)="CambMon('Pesos',2)">
                  @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.usd' | translate}}</span>}
                  @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.mxn' | translate}}</span>}
                  @if(smMoneda === 'Gs'){<span>{{ 'menu.gs' | translate}}</span>} 
                </button>
              </mat-menu>
              <mat-menu #graficasZon2="matMenu">
                <button (click)="stackHoriTabla(false, tipoGraf.STACKEDHORIZONTAL)" mat-menu-item>{{'graf.horizontal'|translate}}</button>
                <button (click)="stackHoriTabla(false, tipoGraf.STACKED)" mat-menu-item>{{'graf.vertical'|translate}}</button>
                <button (click)="stackHoriTabla(true, '')" mat-menu-item>{{'graf.tabla'|translate}}</button>
              </mat-menu>
              <app-menu-perspectivas #menu2 
                [tipo]="submenus" 
                [tablero]="'concentracion2'"
                (eventClick)="filterChange2($event);">
              </app-menu-perspectivas>
            </div>
          </div>
          <!--graficos y tabla de la zona 2-->
          <div class="w3-row" style="height: 34vh; padding-left: 10px;">
            @if (gtablas) {
              <div class="w3-encabezado-table w3-scroll">
                <div class="w3-table-all">
                  <table class="w3-table">
                    <thead>
                      <tr class="w3-table-titleLow w3-center">
                        @for (tit of displayedColumns; track tit; let i = $index) {
                          @if (i === 0) {
                            <th class="stikyColum">{{ 'filtros.periodo' | translate }}</th>
                          }
                          @if (i === 1) {
                            <th class="stikyColum"></th>
                          }
                          @if (i !== 0 && i !== 1) {
                            <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{ dataSource[0].name[i-2] }}</th>
                          }
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (element of dataSource; track element) {
                        <tr class="w3-table-trtd borderInf">
                          @for (inf of displayedColumns; track inf; let i = $index) {
                            <td class="borderAllLow marginsH alinLeft" style="width: 10%; text-wrap: nowrap;">
                              @switch (i) {
                                @case (0) {
                                  <span style="font-weight: bold;">{{ element.periodo }}</span>
                                }
                                @case (1) {
                                  <span style="font-weight: bold;">
                                    {{ element.servicios }} <br />
                                    {{ element.servicios1 }}
                                  </span>
                                }
                                @default {
                                  {{smMoneda}} {{ formatearnormal(element[inf], miles1) }} <br />
                                  {{ formatearnormal2(element[inf + '1']) }}
                                }
                              }
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }@else {
              <app-graficador 
                [etiquetas]="showLabels2"
                [data]="DatosProduct"
                [labels]="etiquetas2"
                [type]="tipoSelec2"
                [axisX]="xAxisLabel2"
                [axisY]="yAxisLabel2"
                [zona]="2"
                [colors]="colorScheme"
                [formatEtiquetas]="true"
                [legend]="{enabled: true, position: 'right'}"
                [animations]="true"
                [speedAnimations]="500"
              ></app-graficador>
            }
          </div>
          
        </div>
        <!--gráfica-->
        <div class="w3-rest w3-light-grey">
          <!--Zona 3-->
          <div class="w3-row" id="Zona3">
            <div class="w3-row w3-right w3-white" style="width: 98%;">
              <!--Encabezado de la zona 3-->
              <div class="w3-row" style="height: 6vh;">
                <!--Titulo de la zona 3-->
                <div class="w3-threequarter w3-titulo-contenidomenu" style="width: 79% !important;">
                  <div class="">
                    <span style="margin-left: 5px;">{{TituloGrafTer | capitalize:'first'}}</span>
                    <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
                    <span class=" w3-margin-left-filter w3-subtitulo">{{subTituloGrafTer | capitalize:'first'}}</span>
                  </div>
                </div>
                <!--Menú de la zona 3-->
                <div class="w3-rest w3-right">
                  <div class="w3-right hijoderechaTitle">
                    @if (!tablaBandas) {
                      <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                        (click)="showLabels3 = !showLabels3" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                        {{ showLabels3 ? 'label_off' : 'label' }}
                      </mat-icon> 
                    }           
                    <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                      (click)="ampliarG3()" onclick="document.getElementById('graficasModal').style.display='block'">zoom_out_map
                    </mat-icon>
                    <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuG3p2">more_vert</mat-icon>
                  </div>
                  <mat-menu #menuG3p2="matMenu" xPosition="before">
                    <!-- <button mat-menu-item>
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">search</mat-icon>
                      <span>Buscar</span>
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="Graficas3p2">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>{{'menu.graficas'|translate}}
                    </button>                
                    <mat-divider></mat-divider>
                    @if (tablaBandas) {
                      <button mat-menu-item (click)="exportBandas()">
                        <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                        <span>{{'menu.Exportar' | translate}}</span>
                      </button>
                    }@else {
                      <button mat-menu-item (click)="export_img(3)">
                        <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                        <span>{{'menu.Exportar' | translate}}</span>
                      </button>
                    }                
                  </mat-menu>
                  <mat-menu #Graficas3p2="matMenu">
                    <button (click)="tableBandas(false,tipoGraf.DONUT)" mat-menu-item>{{'graf.pie'|translate}}</button>
                    <button (click)="tableBandas(false,tipoGraf.HEATMAP)" mat-menu-item>{{'graf.calor'|translate}}</button>
                    <button (click)="tableBandas(false,tipoGraf.BAR)" mat-menu-item>{{'graf.barras'|translate}}</button>
                    <button (click)="tableBandas(true,'')" mat-menu-item>{{'graf.tabla'|translate}}</button>
                  </mat-menu>
                </div>
              </div>
              <!--Graficas de la tercer zona-->
              <div class="w3-row w3-white" style="height: 35vh;" [ngClass]="{'visible': !tablaBandas}">            
                @if (tablaBandas) {
                  <div class="w3-scroll" style="height: 33vh; padding: 10px;">
                    <table class="w3-table">
                      <thead>
                        <tr class="w3-table-titleLow w3-center">
                          <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{'riesgo-credito.concentracion.titBanda'|translate}}</th>
                          <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{'riesgo-credito.concentracion.titVal'|translate}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (element of DatosBanda; track element) {
                          <tr class="w3-table-trtd borderInf">
                            <td class="borderAllLow marginsH alinLeft" style="width: 10%; text-wrap: nowrap;">{{element.name}}</td>
                            <td class="borderAllLow marginsH alinLeft" style="width: 10%; text-wrap: nowrap;">{{formatearnormal(element.value, false)}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>              
                }@else {
                  <app-graficador 
                    [etiquetas]="showLabels3"
                    [data]="data"
                    [labels]="etiquetas3"
                    [type]="tipoSelec3"
                    [axisX]="xAxisLabel3"
                    [axisY]="yAxisLabel3"
                    [zona]="3"
                    [colors]="colorScheme"
                    [formatEtiquetas]="true"
                    [legend]="{enabled: true, position: 'bottom'}"
                    [animations]="true"
                    [speedAnimations]="500"
                  ></app-graficador>
                } 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- The Modal -->
<div id="graficasModal" class="w3-modal">
  @if (!pop) {
    <div class="w3-modal-content" style="width: 90%">
      <div class="w3-row w3-titulo-contenidomenu w3-header-cuadrante">
        <div class="w3-twothird" style="height: 100% ; margin-top: 10px; margin-left: 20px;">          
          <div class="hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{Title | capitalize:'first'}}</span><span
              class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span><span
              class=" w3-margin-left-filter w3-subtitulo">{{Subtitulo_grafica}}</span>
          </div>
        </div>
        <div class="w3-rest w3-right">
          @if (!tablaBandasModal && zona === 3) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              (click)="showLabels3 = !showLabels3" matTooltip="{{'tooltips.tooltipIcono7'|translate}}" style="margin-top: 18px;">
              {{ showLabels3 ? 'label_off' : 'label' }}
            </mat-icon> 
          }
          @if (!gtablaPModal && zona == 1) {
            <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px; margin-top:18px" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels = !showLabels" matTooltip="{{'graf.activar' | translate}}" fontSet="material-icons-outlined">
              {{ !showLabels ? 'label' : 'label_off' }}
            </mat-icon>
          }        
          @if (!gtablasModal && zona == 2) {
            <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px; margin-top:18px" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels2 = !showLabels2" matTooltip="{{'graf.activar' | translate}}" fontSet="material-icons-outlined">
              {{ !showLabels2 ? 'label' : 'label_off' }}
            </mat-icon>
          }        
          @if (!gtablaPModal || !gtablasModal || !tablaBandasModal) {
            <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 3px; margin-top: 18px;" [ngStyle]="{'color':'gray'}" 
            (click)="export_img(zona)" matTooltip="{{'menu.exportar' | translate}}">image</mat-icon>
          }    
          @if (gtablaPModal || gtablasModal || tablaBandasModal) {
            <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 3px; margin-top: 18px;" [ngStyle]="{'color':'gray'}" 
            (click)="tablaBandasModal ? exportBandas() : export_csv(zona)" matTooltip="{{'menu.exportar' | translate}}">description</mat-icon>
          }
          <mat-icon (click)="cerrarAmp()" onclick="document.getElementById('graficasModal').style.display='none'"
            class="w3-margin-right-contenido w3-button w3-dropdown-click" style="margin-top: 18px;margin-right: 24px;">clear</mat-icon>
        </div>
      </div>
      <div class=" w3-row" style="height: 65vh;">
        <div class="w3-row w3-margin" style="height: 56vh;">
          @switch (zona) {
            @case (1) {<!-- ZONA 1 -->
              @if (gtablaPModal) {
                <div class="w3-encabezado-table w3-scroll">
                  <div class="w3-table-all">
                    <table class="w3-table">
                      <thead>
                        <tr class="w3-table-titleLow w3-center">
                          <th class="stikyColum">{{'filtros.periodo' | translate}}</th>
                          <th class="stikyColum w3-border-right-balance"></th>
                          @for(ele of Titulos; track $index){
                            <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{ele}}</th>
                          }
                        </tr>
                      </thead>
                      <tbody class="borderInf borderIzq">
                        @for (element of dataSource2; track element) {
                          <tr class="w3-table-trtd w3-center borderInf">
                            @for (inf of displayedColumns2; track inf; let i = $index) {
                              <td class="borderAllLow marginsH alinLeft" style="width: 10%;">
                                @switch (i) {
                                  @case (0) {
                                    <span style="font-weight: bold;">{{ element.name }}</span>
                                  }
                                  @case (1) {
                                    <span style="font-weight: bold;">
                                      {{ element.servicios }} <br />
                                      {{ element.servicios1 }}
                                    </span>
                                  }
                                  @default {
                                    {{ formatearnormal(element[inf], miles1) }} <br />
                                    {{ formatearnormal2(element[inf + '1']) }}
                                  }
                                }
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }@else {
                <app-graficador 
                  [etiquetas]="showLabels"
                  [data]="stack"
                  [labels]="etiquetas"
                  [type]="tipoSelec"
                  [axisX]="xAxisLabel"
                  [axisY]="yAxisLabel"
                  [zona]="4"
                  [colors]="colorScheme"
                  [formatEtiquetas]="true"
                  [changeLabel]="changeLabel"
                  [legend]="{enabled: true, position: 'right'}"
                  [animations]="false"
                ></app-graficador>
              }
            }
            @case (2) {<!-- ZONA 2 -->
              @if (gtablasModal) {
                <div class="w3-encabezado-table w3-scroll">
                  <div class="w3-encabezado-table w3-scroll">
                    <div class="w3-table-all">
                      <table class="w3-table">
                        <thead>
                          <tr class="w3-table-titleLow w3-center">
                            @for (tit of displayedColumns; track tit; let i = $index) {
                              @if (i === 0) {
                                <th class="stikyColum">{{ 'filtros.periodo' | translate }}</th>
                              }
                              @if (i === 1) {
                                <th class="stikyColum"></th>
                              }
                              @if (i !== 0 && i !== 1) {
                                <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{ dataSource[0].name[i-2] }}</th>
                              }
                            }
                          </tr>
                        </thead>
                        <tbody>
                          @for (element of dataSource; track element) {
                            <tr class="w3-table-trtd borderInf">
                              @for (inf of displayedColumns; track inf; let i = $index) {
                                <td class="borderAllLow marginsH alinLeft" style="width: 10%; text-wrap: nowrap;">
                                  @switch (i) {
                                    @case (0) {
                                      <span style="font-weight: bold;">{{ element.periodo }}</span>
                                    }
                                    @case (1) {
                                      <span style="font-weight: bold;">
                                        {{ element.servicios }} <br />
                                        {{ element.servicios1 }}
                                      </span>
                                    }
                                    @default {
                                      {{smMoneda}} {{ formatearnormal(element[inf], miles1) }} <br />
                                      {{ formatearnormal2(element[inf + '1']) }}
                                    }
                                  }
                                </td>
                              }
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              }@else {
                <app-graficador 
                  [etiquetas]="showLabels2"
                  [data]="DatosProduct"
                  [labels]="etiquetas2"
                  [type]="tipoSelec2"
                  [axisX]="xAxisLabel2"
                  [axisY]="yAxisLabel2"
                  [zona]="5"
                  [colors]="colorScheme"
                  [formatEtiquetas]="true"
                  [legend]="{enabled: true, position: 'right'}"
                  [animations]="false"
                ></app-graficador>
              }
            }
            @case (3) {<!-- ZONA 3 -->
              @if (tablaBandasModal) {
                <div class="w3-scroll" style="height: 100%;">
                  <table class="w3-table">
                    <thead>
                      <tr class="w3-table-titleLow w3-center">
                        <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{'riesgo-credito.concentracion.titBanda'|translate}}</th>
                        <th class="stikyColum w3-border-right-balance" style="line-height: 1.2;">{{'riesgo-credito.concentracion.titVal'|translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (element of DatosBanda; track element) {
                        <tr class="w3-table-trtd borderInf">
                          <td class="borderAllLow marginsH alinLeft" style="width: 10%; text-wrap: nowrap;">{{element.name}}</td>
                          <td class="borderAllLow marginsH alinLeft" style="width: 10%; text-wrap: nowrap;">{{formatearnormal(element.value, false)}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>              
              }@else {
                <app-graficador 
                  [etiquetas]="showLabels3"
                  [data]="data"
                  [labels]="etiquetas3"
                  [type]="tipoSelec3"
                  [axisX]="xAxisLabel3"
                  [axisY]="yAxisLabel3"
                  [zona]="6"
                  [colors]="colorScheme"
                  [formatEtiquetas]="true"
                  [legend]="{enabled: true, position: 'bottom'}"
                  [animations]="false"
                ></app-graficador>
              } 
            }
          }
        </div>
      </div>
    </div>
  }@else {
    <div class="w3-modal-content" (click)="popChange()" style="width: 30%">
      <div class="w3-row w3-titulo-contenidomenu w3-header-cuadrante">
        <div class="w3-twothird">
          <div class="w3-row w3-white w3-header-cuadrante padreizquierda "
            style="height: 6vh; margin-top: 10px; margin-left: 20px;">
            <div class="w3-noventa2 w3-titulo-contenidomenu tooltip bottom hijoizquierdaTitle ">
              <div class="hijoizquierdaTitle">
                <span class="w3-margin-left-contenido">Información</span>
              </div>
            </div>
          </div>
        </div>
        <div class="w3-rest ">
          <mat-icon (click)="cerrarAmp()" onclick="document.getElementById('graficasModal').style.display='none'"
            class="w3-button w3-display-topright " style="margin-top: 18px;margin-right: 24px;">clear</mat-icon>
        </div>
      </div>
      <div class="w3-row" style="padding: 0px 20px;">
        <div class="w3-row " style="height: 98%; ">
          <div class="w3-thirty">
            <div class="w3-row w3-right w3-titulo-contenidomenu">
              <span class="w3-margin-left-contenido">Concentración: </span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="w3-row">
              <b class="w3-titulo-contenidomenu">Por {{elemagrup}}</b>
            </div>
          </div>
        </div>
        <div class="w3-row" style="height: 1vh;"></div>
        <div class="w3-row " style="height: 90%; ">
          <div class="w3-thirty ">
            <div class="w3-row w3-right w3-titulo-contenidomenu ">
              <span class="w3-margin-left-contenido" style="line-height: 1.2; vertical-align: top;">IHH: </span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="w3-row" style="height: 95%;">
              <p class="w3-titulo-contenidomenu" style="font-weight: normal; line-height: 1.2;">El Índice Herfindahl-Hirschman (IHH) es una medición empleada en el
                estudio económico. Esta se centra en los niveles de concentración existentes en los mercados. Es decir, el
                número de empresas que operan en los mismos y su capacidad de poder o de control en ellos.</p>
            </div>
          </div>
        </div>
        <div class="w3-row" style="height: 2vh;"></div>
        <div class="w3-row" style="height: 98%;">
          <div class="w3-thirty">
            <div class="w3-row w3-right w3-titulo-contenidomenu">
              <span class="w3-margin-left-contenido" style="line-height: 1.2; vertical-align: top;">*Nota: </span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="w3-row">
              <p class="w3-titulo-contenidomenu" style="font-weight: normal; line-height: 1.2;">Para estos graficos no se <br> consideran los intereses</p>
            </div>
          </div>
        </div>
        <div class="w3-row" style="height: 2vh;"></div>
        <div class="w3-row" style="height: 2vh;"></div>
      </div>
    </div>
  }  
</div>